class SCopyCoupon extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    this.label = this.querySelector('[data-copy-label]');
    this.initial = this.label?.innerHTML;
    this.querySelector('[id]')?.addEventListener('command', async (event) => {
      if (event.command !== '--copy') return;
      const button = this.querySelector('button');
      const status = this.querySelector('[data-copy-status]');
      try {
        await navigator.clipboard.writeText(this.dataset.code);
        clearTimeout(this.timer);
        button.setAttribute('data-copied', '');
        this.label.textContent = this.dataset.copied;
        status.textContent = this.dataset.copied;
        this.timer = setTimeout(() => {
          button.removeAttribute('data-copied');
          this.label.innerHTML = this.initial;
          status.textContent = '';
        }, 3000);
      } catch {
        status.textContent = this.dataset.error;
        this.label.textContent = this.dataset.error;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => { this.label.innerHTML = this.initial; }, 3000);
      }
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); clearTimeout(this.timer); }
}
if (!customElements.get('s-copy-coupon')) customElements.define('s-copy-coupon', SCopyCoupon);
